<template>
  <div
    v-if="getters.visible"
    class="modal fade show"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-modal="true"
    style="display: block; background-color: rgba(0, 0, 0, 0.3); z-index: 13000;"
    @click.stop="onBackClick"
  >
    <div
      class="popup-dialog modal-dialog modal-dialog-centered modal-sm"
      @click.stop="() => {}"
    >
      <div class="modal-content popup-content">
        <div class="popup-inner">
          <div class="popup-header">
            <h1 class="popup-title" id="exampleModalLabel">
              {{ getters.title }}
            </h1>
            <button
              type="button"
              class="popup-close-btn"
              aria-label="Close"
              @click.stop="onCloseClick"
            >
              <i class="fa-solid fa-x"></i>
            </button>
          </div>

          <div class="popup-body">
            <div v-if="getters.slot"><slot></slot></div>
            <template v-else-if="descriptionParts?.length">
              <div
                v-for="(item, index) in descriptionParts"
                :key="index"
                class="popup-description"
                :class="{ 'popup-description-danger': item.danger }"
              >
                {{ item.text }}
              </div>
            </template>
            <div v-else v-for="(item, index) in descriptions" :key="index" class="popup-description">
              {{ item }}
            </div>
          </div>

          <div class="popup-footer">
            <button
              v-if="getters.showCancel"
              type="button"
              class="popup-btn popup-btn-cancel"
              @click.stop="onCancelClick"
            >
              {{ getters.cancelText }}
            </button>
            <button
              v-if="getters.showOk"
              type="button"
              class="popup-btn popup-btn-primary"
              @click.stop="onOkClick"
            >
              {{ getters.okText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { computed, nextTick } from 'vue';

const store = useStore();
const getters = computed(() => store.getters);
const descriptionParts = computed(() => store.getters.descriptionParts);
const descriptions = computed(() =>
  store.getters.description
    ?.split('\n')
    .filter((item) => item.length > 0)
    .map((item) => `${item}`),
);

const onOkClick = async () => {
  const callback = store.getters.okCallback;
  store.dispatch('hide');
  await nextTick();
  if (callback) {
    try {
      await Promise.resolve(callback());
    } catch (error) {
      console.error(error);
    }
  }
};

const onCancelClick = () => {
  if (getters.value.cancelCallback) {
    getters.value.cancelCallback();
  }
  store.dispatch('hide');
};

const onCloseClick = () => {
  if (getters.value.closeCallback) {
    getters.value.closeCallback();
  } else if (getters.value.cancelCallback) {
    getters.value.cancelCallback();
  }
  //  else if (!getters.value.showCancel && getters.value.okCallback) {
  //   getters.value.okCallback();
  // }
  store.dispatch('hide');
};

const onBackClick = () => {
  if (getters.value.clickable) {
    onCloseClick();
  }
};
</script>

<style scoped>
.popup-dialog {
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2rem);
  max-width: var(--bs-modal-width);
}

.popup-content {
  border-radius: 1.2rem;
  overflow: hidden;
  padding: 0;
}

.popup-inner {
  padding: 1.5rem;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.25rem;
}

.popup-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #212529;
  margin: 0;
}

.popup-close-btn {
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  color: #6c757d;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border-radius: 0.5rem;
  transition: all 0.2s ease;
}

.popup-close-btn:hover {
  background-color: #f8f9fa;
  color: #212529;
}

.popup-body {
  margin-bottom: 1.5rem;
  min-height: 40px;
}

.popup-description {
  font-size: 0.95rem;
  color: #495057;
  line-height: 1.6;
  white-space: pre-line;
}

.popup-description-danger {
  color: #dc3545;
  font-weight: 500;
}

.popup-footer {
  display: flex;
  gap: 0.75rem;
}

.popup-btn {
  flex: 1;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 0.75rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.popup-btn-cancel {
  background-color: #ffffff;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

.popup-btn-cancel:hover {
  background-color: #f8f9fa;
  border-color: #adb5bd;
}

.popup-btn-primary {
  background-color: #0d6efd;
  color: #ffffff;
}

.popup-btn-primary:hover {
  background-color: #0b5ed7;
}
</style>
